import BaseApp from 'App';

export default (BaseApp);
